import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'i18n';
import { mediaQueries } from 'styles/utils/mediaQueries';

function TabComponent({ id, label, selected, onClick }) {
  const { id: labelId, description, defaultMessage } = label;

  return (
    <Root selected={selected} onClick={onClick} data-tab-id={id}>
      <FormattedMessage id={labelId} description={description} defaultMessage={defaultMessage} />
    </Root>
  );
}

export default TabComponent;

const Root = styled.button`
  height: 48px;
  padding-left: 30px;
  background-color: ${({ selected, theme }) => (selected ? theme.colors.background.light : theme.colors.primary.light)};
  border: none;
  border: 1px solid ${({ theme }) => theme.colors.primary.default};
  border-width: 1px 0 1px 1px;
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primary.dark};
  text-align: left;
  letter-spacing: 0.3px;
  cursor: pointer;

  :first-child {
    border-bottom-width: 0;
    border-top-left-radius: 4px;
  }

  :last-child {
    box-sizing: content-box;
    border-bottom-left-radius: 4px;
  }

  ${mediaQueries.fromAndAbove.tablet`
    ${({ selected }) =>
      selected &&
      `
      position: relative;
      left: 1px;
      border-right-width: 0;
    `}
  `}

  ${mediaQueries.fromAndBelow.tablet`
    width: 100%;
    border-width: 1px 1px 0 1px;

    :first-child {
      border-right-width: 0;
    }

    :last-child {
      box-sizing: border-box;
      border-bottom-left-radius: 0;
      border-top-right-radius: 4px;
    }
  `}
`;
